module.exports = __webpack_public_path__ + "img/scholar1.deb40dd7.png";